// extracted by mini-css-extract-plugin
module.exports = {"item":"Icons_item__dht_g","fill":"Icons_fill__fAyyz","button":"Icons_button__z2xkN","link":"Icons_link__0q7BU","icon":"Icons_icon__ngxUj","text":"Icons_text__TPucZ"};